// Resize logic is copied from https://github.com/vippsas/ecom-landing-page-frontend/blob/main/src/core/util/iframeResize.ts
export function initIframeResizeReporter(element: HTMLElement): () => void {
  if (window.parent === window) return () => undefined;

  let lastWidth = 0;
  let lastHeight = 0;

  const postSize = () => {
    const width = element.scrollWidth;
    const height = element.scrollHeight;

    const hasWidthChanged = Boolean(width - lastWidth);
    const hasHeightChanged = Boolean(height - lastHeight);

    if (!hasWidthChanged && !hasHeightChanged) {
      return;
    }

    lastWidth = width;
    lastHeight = height;

    window.parent.postMessage({ source: 'vipps-widget-sdk', event: 'resize', width, height }, '*');
  };

  if (typeof ResizeObserver === 'undefined') {
    // fallback for environments without resize observer (older iOS/android webviews)
    const intervalId = setInterval(postSize, 500);
    postSize();

    return () => {
      clearInterval(intervalId);
    };
  }

  const observer = new ResizeObserver(postSize);
  observer.observe(element);

  postSize();

  return () => observer.disconnect();
}
